import type { FC } from "react";
import React, { useEffect } from "react";
import { Box, Drawer } from "@edreamsodigeo/prisma-design-system";
import { useRouter, useTracking } from "@edreamsodigeo/frontend-core";

import { usePrimeSubscriptionModalUI } from "~/clientState/providers/PrimeSubscriptionModalProvider";
import LightboxOffer from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxOffer";
import { LightboxHeaderDesktop } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxHeader";
import { LightboxFooter } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxFooter";
import { LightboxBenefitsDesktop } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxBenefits";
import type { LightboxRevampProps } from "~/components/acquisition/Lightbox/LightboxRevamp/contracts";
import LightboxSavingsTable from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxSavingsTable";
import {
  ActionsEnum,
  getCategoryLabel,
  trackingLabels,
} from "../config/tracking";

const LightboxRevampDesktop: FC<LightboxRevampProps> = ({
  basicOffer,
  plusOffer,
  freeTrialDays,
}) => {
  const { trackEvent } = useTracking();
  const { pathname } = useRouter();
  const { isOpen, close } = usePrimeSubscriptionModalUI();

  const onCloseWithTracking = (): void => {
    trackEvent({
      category: getCategoryLabel(pathname),
      action: ActionsEnum.PRIME_LIGHTBOX,
      label: trackingLabels.onClose({
        pathname: pathname,
      }),
    });
    close();
  };

  useEffect(() => {
    if (isOpen) {
      trackEvent({
        category: getCategoryLabel(pathname),
        action: ActionsEnum.PRIME_LIGHTBOX,
        label: trackingLabels.onLoad({
          pathname: pathname,
        }),
      });
    }
  }, [isOpen, pathname, trackEvent]);

  return (
    <Drawer open={isOpen} size={"large"} onDismiss={onCloseWithTracking} fixed>
      <Box sx={{ overflowY: "scroll" }}>
        <LightboxHeaderDesktop
          onClose={onCloseWithTracking}
          freeTrialDays={freeTrialDays}
        />
        <LightboxOffer basicOffer={basicOffer} plusOffer={plusOffer} />
        <LightboxBenefitsDesktop
          extraElements={[
            {
              category: "lightboxPrimeRevampDesktop.table.section.title",
              element: <LightboxSavingsTable />,
              position: 1,
            },
          ]}
        />
        <Box sx={{ margin: "0 32px 32px" }}>
          <LightboxFooter
            onClose={() => close()}
            basicOffer={basicOffer}
            plusOffer={plusOffer}
          />
        </Box>
      </Box>
    </Drawer>
  );
};

export default LightboxRevampDesktop;
